import { useState, useMemo, useCallback } from 'react';
import last from 'lodash/last';
import isFunction from 'lodash/isFunction';

import { NETWORK_STATES } from 'api/base';

export default (initialState = NETWORK_STATES.IDDLE) => {
  const [networkState, setNetworkState] = useState(initialState);
  const [networkErrors, setNetworkErrors] = useState([]);

  const isLoading = useMemo(
    () => [NETWORK_STATES.LOADING, NETWORK_STATES.SENDING].includes(networkState),
    [networkState],
  );

  const lastNetworkErrors = useMemo(() => last(networkErrors), [networkErrors]);

  const setIsLoading = useCallback((isEntryIngest = false) => {
    setNetworkState(isEntryIngest ? NETWORK_STATES.SENDING : NETWORK_STATES.LOADING);
  }, []);

  const setDoneLoading = useCallback(() => {
    setNetworkState(NETWORK_STATES.SUCCESS);
  }, []);

  const setFailedLoading = useCallback(errors => {
    setNetworkState(NETWORK_STATES.FAILURE);
    setNetworkErrors(_errors => _errors.concat([errors]));
  }, []);

  const onDoneBy = useCallback((status, callbacks) => {
    try {
      callbacks[status]();
    } catch (_) {
      isFunction(callbacks._) && callbacks._();
    }
  }, []);

  return {
    state: networkState,
    errors: networkErrors,
    setIsLoading,
    setDoneLoading,
    setFailedLoading,
    isLoading,
    lastNetworkErrors,
    onDoneBy,
  };
};
